import { defineComponent as _defineComponent } from 'vue'
import { Empty } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoMessages',
  setup(__props) {

const simpleImage = (Empty as typeof Empty & { PRESENTED_IMAGE_SIMPLE: string }).PRESENTED_IMAGE_SIMPLE;

return { __sfc: true,simpleImage }
}

})